var _jsxFileName = "/codebuild/output/src2357418120/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/utility/RichText/List.tsx";
import React from 'react';
import { HStack, Stack, Text } from '@adc/parallax-component-library';
export const ListItem = ({
  children,
  fontToken,
  testID
}) => {
  if (!(children !== null && children !== void 0 && children.length)) {
    return null;
  }
  const textChildren = children.filter(child => typeof child === 'string' || child.type === Text);
  const restChildren = children.filter(child => typeof child !== 'string' && child.type !== Text);
  return /*#__PURE__*/React.createElement(Stack, {
    tag: "li",
    style: {
      display: 'list-item'
    },
    testID: testID,
    nativeID: testID,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(HStack, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Text, {
    type: fontToken,
    flexShrink: 1,
    testID: `${testID}-text`,
    nativeID: `${testID}-text`,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 9
    }
  }, textChildren)), /*#__PURE__*/React.createElement(Stack, {
    marginLeft: "$2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 7
    }
  }, restChildren));
};
ListItem.displayName = 'ListItem';
export const List = ({
  children,
  listType = 'ul',
  testID
}) => {
  return /*#__PURE__*/React.createElement(Stack, {
    tag: listType,
    paddingInlineStart: "$6",
    marginInlineStart: 0,
    marginInlineEnd: 0,
    marginBlockStart: "$2",
    marginBlockEnd: "$2",
    justifyContent: "center",
    style: {
      listStyleType: listType === 'ol' ? 'decimal' : 'disc'
    },
    testID: testID,
    nativeID: testID,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42,
      columnNumber: 5
    }
  }, children);
};